require('./AFISimulator.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');

// @ actions
const revolvingActions = require('actions/cardRevolvingDocuments');

// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { getCardType } = require('utilities/cardsHelper');

// @ commons
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { OKMessage } = require('commonsComponents/OKMessage');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ constants
const {
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_VARIABLE,
    OCULTO_ENVIRONMENT,
    PRODUCTION_ENVIRONMENT,
} = require('constants/index');
const {
    APLAZADO_TAE,
    APLAZADO_TIN,
    CALCULATION_TYPE_FIXED_FEE,
    CALCULATION_TYPE_VARIABLE_FEE,
    LOW_FEE_ERROR,
} = require('constants/AFISimulator.js');

class AFISimulator extends React.Component {
    componentDidMount(){
        this.calculate();
    }

    componentDidUpdate() {
        if (this.paramsHaveChanged()){
            this.calculate();
        }
    }

    componentWillUnmount() {
        this.props.requestAfiInformationReset();
    }

    calculate() {
        const {
            amount,
            immCard,
            installments,
            method,
            requestAfiInformation,
            setAFIParams,
        } = this.props;

        const cardType = getCardType(immCard);
        const tin = this.getInterest(cardType, APLAZADO_TIN);
        const calculationType = this.getCalculationTypeByPaymentMethod(method);
        const interestRate = Number(tin.replace('%', '').replace(',','.')) / 100;
        const paymentValueParamName = calculationType === CALCULATION_TYPE_FIXED_FEE ? 'FixedPaymentAmount' : 'PercentagePaymentRate';
        const paymentValue = calculationType === CALCULATION_TYPE_VARIABLE_FEE ? installments / 100 : installments;

        setAFIParams({
            amount,
            calculationType,
            installments,
            interestRate,
            method,
            typePayment: paymentValueParamName,
            valuePayment: paymentValue,
        });

        requestAfiInformation(amount);

    }

    getInterest = (creditType, type) => {
        const {
            immGlobalVariables,
            revolvingPackId,
        } = this.props;

        const values = {
            'DIAMOND_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'pack_diamond', type]),
            'OPEN_CREDIT_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', type]),
            'PREMIUM_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'pack_premium', type]),
            'REVOLVING_CARD': immGlobalVariables.getIn(['variables', 'parameters', `revolving_pack_${revolvingPackId}`, type]),
            'VIAT_CARD': immGlobalVariables.getIn(['variables', 'parameters', 'via-t', type]),
        };

        return values[creditType];
    }

    getCalculationTypeByPaymentMethod(paymentMethod) {
        let calculationType;

        switch (paymentMethod) {
            case CARD_PAYMENT_METHOD_FIXED:
                calculationType = CALCULATION_TYPE_FIXED_FEE;
                break;
            case CARD_PAYMENT_METHOD_VARIABLE:
                calculationType = CALCULATION_TYPE_VARIABLE_FEE;
                break;
            default:
                calculationType = CALCULATION_TYPE_FIXED_FEE;
        }

        return calculationType;
    }

    buildMessageError() {
        const { immPdfRevolvingPersistent } = this.props;
        const error = immPdfRevolvingPersistent.get('error');
        let errorMessage;

        if (error === LOW_FEE_ERROR){
            errorMessage = (
                <section className="afi-simulator__error-wrapper">
                    <OKMessage type="warning">
                        <div className="afi-simulator__error-title">
                            <FormattedText value="afiSimulator-afiSimulator_lowFeeErrorTitle"/>
                        </div>
                        <div className="afi-simulator__error-text">
                            <FormattedText value="afiSimulator-afiSimulator_lowFeeErrorContent"/>
                        </div>
                    </OKMessage>
                </section>
            );
        } else {
            errorMessage = (
                <section className="afi-simulator__error-wrapper">
                    <OKMessage type="warning">
                        <div className="afi-simulator__error-title">
                            <FormattedText value="hirePaymentMethodComponent-hirePaymentMethodComponent_iframeErrorTitle"/>
                        </div>
                        <div className="afi-simulator__error-text">
                            <FormattedText value="hirePaymentMethodComponent-hirePaymentMethodComponent_iframeErrorContent"/>
                        </div>
                        <div className="afi-simulator__error-text">
                            <FormattedText value="hirePaymentMethodComponent-hirePaymentMethodComponent_iframeErrorFooter"/>
                        </div>
                    </OKMessage>
                </section>
            );
        }

        return errorMessage;
    }

    paramsHaveChanged() {
        const { 
            amount,
            immPdfRevolvingPersistent,
            installments,
            method,
        } = this.props;

        const revolvingData = immPdfRevolvingPersistent.get('paramsAFI');

        return revolvingData.get('amount') !== amount || revolvingData.get('installments') !== installments || revolvingData.get('method') !== method;
    }

    buildSimulatorContent() {
        const { 
            immCard,
            immPdfRevolvingPersistent,
            installments,
            method,
        } = this.props;

        const calculationType = this.getCalculationTypeByPaymentMethod(method);
        const cardType = getCardType(immCard);
        const tin = this.getInterest(cardType, APLAZADO_TIN);
        const tae = this.getInterest(cardType, APLAZADO_TAE);
        const error = immPdfRevolvingPersistent.get('isIframeError');
        const success = immPdfRevolvingPersistent.get('isIframeSuccess');
        const loading = immPdfRevolvingPersistent.get('isIframeIsFetching');

        if (loading || success && this.paramsHaveChanged()){
            return (<LoadingSection />)
        } else if (success) {
            return (
                <React.Fragment>
                    <div className="afi-simulator__simulator-iframe">
                        <iframe
                            className={'afi-simulator__afi-iframe'}
                            frameBorder="no"
                            src={this.buildAFISimulatorURL(calculationType, tin, installments)}
                        />
                    </div>
                    <div className="afi-simulator__payment-conditions">
                        <FormattedText
                            value="hirePaymentMethodComponent-hirePaymentMethodComponent_settlementMaxTime"
                        />
                        <FormattedText
                            value="hirePaymentMethodComponent-hirePaymentMethodComponent_interestType"
                            injectedStrings={[tin, tae]}
                        />
                    </div>
                </React.Fragment>
            );
        } else if (error) {
            return this.buildMessageError();
        }

        return null;
    }

    buildAFISimulatorURL(calculationType, tin, value) {
        const { amount } = this.props;
        const interestRate = Number(tin.replace('%', '').replace(',','.')) / 100;
        const paymentValueParamName = calculationType === CALCULATION_TYPE_FIXED_FEE ? 'FixedPaymentAmount' : 'PercentagePaymentRate';
        const paymentValue = calculationType === CALCULATION_TYPE_VARIABLE_FEE ? value / 100 : value;
        let urlParams = `?interestRate=${interestRate}&Amount=${amount}&CalculationType=${calculationType}&${paymentValueParamName}=${paymentValue}`;

        const language = getLanguage();

        if (language !== 'es') {
            urlParams += '&lang=en-US';
        }

        let url = formatText('hirePaymentMethodComponent-hirePaymentMethodComponent_AFISimulatorURLPRO');

        if (window.__ENV__ !== PRODUCTION_ENVIRONMENT && window.__ENV__ !== OCULTO_ENVIRONMENT) {
            url = formatText('hirePaymentMethodComponent-hirePaymentMethodComponent_AFISimulatorURLPRE');
        }

        return `${url}${urlParams}`;
    }

    buildInfoMessageCC() {
        return __CONTACT_CENTER__ && (
            <BlockInfo extraClass="afi-simulator__block-info">
                <p>
                    <b>
                        <FormattedText value="hirePaymentMethodComponent-hirePaymentMethodComponent_TitleCC"/>
                    </b>
                </p>
                <p>
                    <FormattedText value="hirePaymentMethodComponent-hirePaymentMethodComponent_ContentCC"/>
                </p>
            </BlockInfo>
        )
    }

    render() {
        return (
            <div>
                {this.buildInfoMessageCC()}
                <div className="row">
                    {this.buildSimulatorContent()}
                </div>
            </div>
        )
    }
}

AFISimulator.propTypes = {
    amount: PropTypes.number.isRequired,
    immCard: PropTypes.object,
    immGlobalVariables: PropTypes.object,
    immPdfRevolvingPersistent: PropTypes.object,
    installments: PropTypes.number,
    method: PropTypes.string,
    requestAfiInformation: PropTypes.func,
    requestAfiInformationReset: PropTypes.func,
    revolvingPackId: PropTypes.number,
    setAFIParams: PropTypes.func,
};

module.exports.constructor = AFISimulator;
module.exports.AFISimulator = connect(
    state => ({
        immPdfRevolvingPersistent: state.revolvingPersistentData
    }),
    {
        requestAfiInformation: revolvingActions.requestAfiInformation,
        requestAfiInformationReset: revolvingActions.requestAfiInformationReset,
        setAFIParams: revolvingActions.setAFIParams,
    }
)(AFISimulator);
